//Filter result Tooltip on landing page
export const FILTER_TOOL_TIP =
  'You are filtering on your previous results. Click the "View Results" button to update the results first.';
export const SDF_CREATE_WARNING_MESSAGE_HEADER =
  'SBF must be completed before the strategy is published.';
export const SDF_CREATE_CRITICAL_WARNING_MESSAGE_DESCRIPTION =
  'The U.S. government requires John Deere to document whether or ' +
  'not Small Businesses were considered in sourcing ' +
  'decisions. ';
export const SPLR_ALREADY_EXISTS_ON_STRATEGY =
  'Supplier already exists on this strategy.';
export const SPLR_ALREADY_EXISTS_ON_NON_STRATEGIC_TAB =
  'Supplier already exists on Non Strategic tab, please update status there.';
